var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGanttChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.721,
    height: 17.766,
    viewBox: "0 0 16.721 17.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-gantt-chart-1916201",
    transform: "translate(-163.334 -70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4589",
    "data-name": "Path 4589",
    d: "M176.919,71.045h-1.045v-.522a.522.522,0,1,0-1.045,0v.522h-6.27v-.522a.522.522,0,1,0-1.045,0v.522h-1.045a3.135,3.135,0,0,0-3.135,3.135V84.631a3.135,3.135,0,0,0,3.135,3.135H176.92a3.135,3.135,0,0,0,3.135-3.135V74.18a3.135,3.135,0,0,0-3.135-3.135Zm0,15.675H166.469a2.092,2.092,0,0,1-2.09-2.09V76.27h14.63v6.27h-7.838a.51.51,0,0,0-.259.078.5.5,0,0,0-.052.036.516.516,0,0,0-.17.208h0v.005h0a.519.519,0,0,0-.039.2.459.459,0,0,0,.013.067.468.468,0,0,0,.013.067.517.517,0,0,0,.127.236l1.044,1.044a.522.522,0,0,0,.739,0l.892-.892h5.531V84.63a2.092,2.092,0,0,1-2.09,2.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4590",
    "data-name": "Path 4590",
    d: "M241.694,280.525a.522.522,0,0,0-.523-.523h-7.315a.51.51,0,0,0-.259.078.483.483,0,0,0-.052.036.516.516,0,0,0-.17.208h0v.005h0a.522.522,0,0,0-.039.2.51.51,0,0,0,.013.067.486.486,0,0,0,.014.067.517.517,0,0,0,.127.236l1.044,1.044a.522.522,0,0,0,.739,0l.892-.892h5.009a.522.522,0,0,0,.523-.522Z",
    transform: "translate(-66.865 -200.597)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttChart);
export default __webpack_public_path__ + "static/media/gantt-chart.6a2b355608e94b159ad012b7c0f9d26e.svg";
export { ForwardRef as ReactComponent };